import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { Logo } from "components/logo"
import { PageLoader } from "components/page-loader"
import { SignInForm } from "components/signin-form"
import { useAuth } from "hooks/use-auth"
import { useEffect } from "react"
import { z } from "zod"
import { getRegionDetails } from "@/server/region.server"

const signInSearchSchema = z.object({
  redirect: z.string().optional(),
})

export const Route = createFileRoute("/_public/sign-in/")({
  loader: async () => {
    const regionDetails = await getRegionDetails()
    return { regionDetails }
  },
  validateSearch: signInSearchSchema,
  component: RouteComponent,
})

function RouteComponent() {
  const { isAuthenticated, isLoading } = useAuth()
  const navigate = useNavigate()
  const search = Route.useSearch()
  const { regionDetails } = Route.useLoaderData()

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      const redirectTo = search.redirect || "/personal/dashboard"
      navigate({ to: redirectTo })
    }
  }, [isAuthenticated, isLoading, navigate, search.redirect])

  if (isLoading) {
    return <PageLoader />
  }

  if (isAuthenticated) {
    return null // Will redirect in useEffect
  }

  return (
    <div className="grid min-h-svh lg:grid-cols-2">
      <div className="flex flex-col gap-8 p-6 md:p-10 items-center justify-center">
        <div className="">
          <Logo />
        </div>
        <div className="w-full max-w-xs">
          <SignInForm redirect={search.redirect} regionDetails={regionDetails} />
        </div>
      </div>
      <div className="bg-sky-100 p-12 flex items-center justify-center">
        <img src="/images/login_illustration.svg" alt="Illustration" className="object-contain" />
      </div>
    </div>
  )
}
